// The pipeline's sort header. This screen is not a table — it is stage sections of
// collapsible cards — so there is no <thead> to hang the control on, and DataTable
// cannot be reused. What CAN be reused is everything that matters: the same
// useTableSort hook, the same ▲/▼ behaviour, and the same rule that clicking the
// sorted column flips it while clicking another starts it ascending.
//
// ONE strip for the whole screen, not one per stage. Sorting applies identically
// inside every section, and a header repeated above each stage would both be noise
// and imply the sections sort independently, which they do not.
//
// The strip is laid out on the SAME grid metrics as the cards beneath it (the CSS
// variables in leads.css), so a label sits over the column it orders. The identity
// column carries two labels — a card shows the organisation and its contact stacked
// in that one cell, and either can order it.
export default function LeadSortBar({ columns, sort, onSort }) {
  const cell = (c) => {
    const active = sort && sort.key === c.key;
    return (
      <button
        key={c.key}
        type="button"
        className={`lead-sort-th${active ? ' is-active' : ''}`}
        onClick={() => onSort(c.key)}
        aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : undefined}
      >
        {c.label}
        <span className={`sort-arrow${active ? ' on' : ''}`}>
          {active ? (sort.dir === 'asc' ? '▲' : '▼') : '↕'}
        </span>
      </button>
    );
  };

  const [name, contact, ...rest] = columns;
  return (
    <div className="lead-sortbar">
      {/* Spacers for the cells that hold no value to sort by: the tick, chevron and
          monogram at the start, the stage pill and ⋯ menu at the end. */}
      <span className="lead-sortbar-gap" aria-hidden="true" />
      <span className="lead-sort-identity">{cell(name)}{cell(contact)}</span>
      {rest.map(cell)}
      <span className="lead-sortbar-gap" aria-hidden="true" />
    </div>
  );
}
